import { useCallback, useContext, useEffect, useState } from "react";

import { usePlaidLink, PlaidLinkOnSuccess } from "react-plaid-link";

import { Button } from "@chakra-ui/react";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { apiRequest } from "utils/api";
import { AlertsContext } from "providers/alerts";
import { getCustomButtonVariant } from "utils/uiconfighelper";
import { getErrorMessage } from "utils/errorHandler";
import { useCurrentUserQuery } from "modules/tenant/queries/use-current-user-query";

const CreatePlaidTokenButton = ({ accounts }: { accounts: any[] }) => {
  const { showError } = useContext(AlertsContext);
  const { user } = useTenant();
  const { refetch } = useCurrentUserQuery();
  const [syncing, setSyncing] = useState(false);
  const [token, setToken] = useState<string | null>(null);

  const onSuccess = useCallback<PlaidLinkOnSuccess>(async (public_token, metadata) => {
    try {
      setSyncing(true);
      await apiRequest("/supabase/plaid_tokens/insert", {
        public_token,
      });
      await refetch();
    } catch (err) {
      showError({
        title: "Connection Failed",
        description: getErrorMessage(err),
      });
    } finally {
      setSyncing(false);
    }
  }, []);

  const createLinkToken = async () => {
    try {
      const response = await apiRequest("/plaid/createToken");
      setToken(response.link_token);
    } catch (err) {
      showError({
        title: "Integration Failed",
        descrption: getErrorMessage(err),
      });
    }
  };

  const { open, ready } = usePlaidLink({
    token,
    onSuccess,
  });

  useEffect(() => {
    if (ready) {
      open();
    }
  }, [ready, open]);

  return (
    <Button
      w="100%"
      isLoading={syncing}
      onClick={createLinkToken}
      variant={accounts.length > 0 ? "secondary" : getCustomButtonVariant(user)}
      disabled={!ready}
    >
      {accounts.length > 0 ? "Manage" : "Connect"} Bank Accounts
    </Button>
  );
};

export default CreatePlaidTokenButton;
